module.exports = __webpack_public_path__ + "static/media/SleepConsultationInner.b6005355.png";